const getThemeClassResolver = (themeTypes, prefix, theme) => {
	if (themeTypes.find(theme_ => theme === theme_)) {
		return {
			[`${prefix}${theme}`]: true,
		}
	}
	return null
}

export default getThemeClassResolver
